/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import "../bootstrap";
import "../plugins";
import Vue from "vue";
import axios from "axios";

// import Vuex from "vuex";
import JollyGoComponent from "./components/JollyGoComponent.vue";
import ValidateCheckin from "./components/ValidateCheckin.vue";

Vue.use(axios);
// Vue.use(Vuex);

const app = new Vue({
  el: "#app",
  components: { JollyGoComponent, ValidateCheckin },
  data: {
    isLogoutVisible: true,
  },
  methods: {
    hideLogout() {
      this.isLogoutVisible = false;
    },
  },
});
